import { a, list, p, richP, s, subheading, t } from "./legal-types";
const MCP_URL = "https://api.agent-gate.com/agent-todo/mcp";
/** "name: what it does", one line per tool */
const tool = (name, what) => `${name}: ${what}`;
const tools = (...items) => list(...items.map(([name, what]) => tool(name, what)));
export const DOCS = {
    title: "Agent Todo for Claude",
    lastUpdated: "October 2026",
    sections: [
        {
            title: "What it does",
            blocks: [
                p("Agent Todo connects Claude to the task app you already use: Microsoft To Do, Google Tasks or Todoist. Ask Claude to read, add, update or finish tasks, and the change lands in your own task app."),
                p("Agent Todo stores your provider sign-in, encrypted. It does not keep its own copy of your tasks unless you turn on cross-provider sync."),
            ],
        },
        {
            title: "Before you connect",
            blocks: [
                richP(t("1. Sign in at "), a("agent-todo.com", "https://agent-todo.com/login", true), t(" with Google, GitHub or email.")),
                richP(t("2. On "), a("Connections", "https://agent-todo.com/connections", true), t(", connect Microsoft To Do, Google Tasks or Todoist. You sign in to that provider and approve access.")),
                p("The Free plan includes one provider with full read and write. Pro adds every provider, sync between them, scheduled digests and email-to-task."),
            ],
        },
        {
            title: "Connect Claude",
            blocks: [
                subheading("Claude on the web, Desktop and mobile"),
                richP(t("Open "), a("Agent Todo in Claude's connector directory", "https://claude.ai/directory/agent-todo", true), t(" and select Connect. Sign in to Agent Todo and approve access.")),
                p("Or, in Claude, open Settings, then Connectors, choose Add custom connector and enter the URL below."),
                richP(s("Server URL: "), t(MCP_URL)),
                subheading("Claude Code"),
                richP(t(`claude mcp add --transport http agent-todo ${MCP_URL}`)),
                p("Claude Code opens your browser to sign in the first time you use a tool."),
            ],
        },
        {
            title: "Try asking",
            blocks: [
                list("What's due this week?", 'Add "Renew passport" to my Personal list, due Friday, high priority.', 'Mark "Send invoice" as done.', "Move the dentist appointment task to next Tuesday.", "Find every task that mentions the budget.", "Create a list called Trip planning and add packing, tickets and hotel."),
            ],
        },
        {
            title: "Tools",
            blocks: [
                p("Claude asks before it runs a tool that changes or deletes data. Read-only tools run without asking."),
                subheading("Read only"),
                tools(["list_task_lists", "your lists in every connected provider"], ["list_tasks", "the tasks in a list, with status, due date and priority"], ["search_tasks", "tasks that match a keyword, across all lists"], ["search and fetch", "find tasks, then read their full details"], ["get_sync_status", "the state of cross-provider sync (Pro)"], ["get_list_sync_configs", "which lists sync where (Pro)"], ["get_cross_provider_sync_mappings", "the history of synced tasks (Pro)"]),
                subheading("Adds data"),
                tools(["create_task", "add a task to a list"], ["complete_task", "mark a task done (undo with update_task)"], ["create_task_list", "add a list"], ["set_default_provider", "choose the provider new tasks go to"], ["set_primary_provider", "choose the provider sync copies into (Pro)"], ["trigger_sync", "run cross-provider sync now (Pro)"], ["sync_to_primary", "copy tasks into the primary provider (Pro)"]),
                subheading("Changes or deletes data"),
                tools(["update_task", "change a task's title, notes, due date, priority or status"], ["delete_task", "delete a task for good"], ["update_task_list", "rename a list"], ["delete_task_list", "delete a list and its tasks for good"], ["configure_list_sync", "set how a list syncs (Pro)"], ["delete_list_sync_config", "stop syncing a list (Pro)"]),
            ],
        },
        {
            title: "Disconnect",
            blocks: [
                p("Remove Agent Todo under Connectors in Claude to stop Claude's access."),
                richP(t("Disconnect a provider on "), a("Connections", "https://agent-todo.com/connections", true), t(", or delete your account on the Account page to remove everything we store.")),
            ],
        },
        {
            title: "Help",
            blocks: [
                richP(t("Email "), a("support@agent-todo.com", "mailto:support@agent-todo.com"), t(". See also the "), a("Privacy Policy", "https://agent-todo.com/privacy", true), t(" and "), a("Terms of Service", "https://agent-todo.com/terms", true), t(".")),
            ],
        },
    ],
};
